import RpmModalHeader from "./RpmModalHeader"

export default  RpmModalHeader;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmModalHeader/index.js